import { Skeleton } from '../../../../Skeleton'

import { getCalendarGridWeekColumnSkeletonStyle } from './CalendarGridWeekColumnSkeleton.utils'

import * as styles from './CalendarGridWeekColumnSkeleton.module.css'

function CalendarGridWeekColumnSkeleton({ dayIndex }) {
  return (
    <Skeleton
      className={styles.CalendarGridWeekColumnSkeleton}
      style={getCalendarGridWeekColumnSkeletonStyle(dayIndex)}
    />
  )
}

export default CalendarGridWeekColumnSkeleton
